import { Loading } from "app/components/Loading";
import { ErrorMessageBox } from "bf-library";
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { RecommendBookList } from "./RecommendBookList";

export const ThemeRecommendBooks = ({themeId})=>{
    const {data:bookList, isLoading, isError, error} = useQuery({
        queryKey:['recommend/id/books', themeId],
        queryFn:()=>Api.get(`/api/recommend/${themeId}/books`),
        staleTime:1000*60*60,
        gcTime:1000*60*60,
    });

    if(isLoading)return <Loading />;
    if(isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

    return <RecommendBookList list={bookList.data.map(recommend=>recommend.book)} />;
};